<template>
  <div>
    <XDateType
      v-if="showDateType"
      :label="labelIcon('fa/light/image')"
      icon="fa/light/image"
      :date="reaction.relativeDate"
    />

    <XCard>
      <silentbox-single
        slot="header"
        :src="reaction.url"
      >
        <img
          :src="reaction.url"
          class="block w-full"
          alt="Image"
        >
      </silentbox-single>

      <XReactionFooter
        v-if="shareChannels"
        :reaction="reaction"
        :shareChannels="shareChannels"
        :shareMessage="shareMessage"
        :shareHashtags="shareHashtags"
        :shareDescription="shareDescription"
        :allowExpressions="allowExpressions"
        :showShare="showShare"
        :showExpressions="showExpressions"
      />
    </XCard>
  </div>
</template>

<script>
import ReactionMixin from './ReactionMixin'

export default {
  mixins: [
    ReactionMixin
  ]
}
</script>
